var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDoubleArrowRotate = function SvgDoubleArrowRotate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_159_13059)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.0013 3.33398V1.58398L10.3346 3.91732L8.0013 6.25065V4.50065C6.07047 4.50065 4.5013 6.06982 4.5013 8.00065C4.5013 8.58982 4.64714 9.14982 4.90964 9.63398L4.05797 10.4857C3.60297 9.76815 3.33463 8.91648 3.33463 8.00065C3.33463 5.42232 5.42297 3.33398 8.0013 3.33398ZM8.0013 11.5007C9.93214 11.5007 11.5013 9.93149 11.5013 8.00065C11.5013 7.41148 11.3555 6.85148 11.093 6.36732L11.9446 5.51565C12.3996 6.23315 12.668 7.08482 12.668 8.00065C12.668 10.579 10.5796 12.6673 8.0013 12.6673V14.4173L5.66797 12.084L8.0013 9.75065V11.5007Z",
    fill: "#65748C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_159_13059"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "matrix(-1 0 0 1 15 1)"
  })))));
};
export default SvgDoubleArrowRotate;